import actions from 'actions'

const defaultState = {
  currentEditingPromoCodeId: null,
}

export default function promoCodePage(state = defaultState, action) {
  switch (action.type) {
    case actions.PROMO_CODE_SET_EDITING_PROMO_CODE:
      return {
        ...state,
        currentEditingPromoCodeId: action.promoCodeId,
      }
    default:
      return state
  }
}



/** WEBPACK FOOTER **
 ** ./src/reducers/pages/promo-code-page/promo-code-page.js
 **/